import DashboardPage from './ducks/DashboardPage.duck';

export default {
  DashboardPage,
};
